import React from 'react'
import { selectFullLicense, lookupLicenseProductId, humanizeDays } from '../models/plans'
import { State } from '../store'
import { LicensingTitle } from './LicensingTitle'
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'
import { Notice } from './Notice'
import { Link } from './Link'
import { BillingUI } from './BillingUI'

type Props = { device?: IDevice; license?: ILicense }

export const LicensingServiceNotice: React.FC<Props> = props => {
  const { noticeType, license, serviceLimit, evaluationLimit } = useSelector((state: State) => {
    let productId = props.license?.plan.product.id
    if (props.device && state.auth.user?.id === props.device.owner.id) productId = lookupLicenseProductId(props.device)
    return selectFullLicense(state, { productId })
  })

  if (!license) return null

  const title = `Your ${license.plan.description} license of ${license.plan.product.name}`

  if (noticeType === 'LIMIT_EXCEEDED')
    return (
      <Notice
        severity="warning"
        button={
          <BillingUI>
            <Link to="/account/plans">
              <Button color="primary" variant="contained" size="small">
                Upgrade
              </Button>
            </Link>
          </BillingUI>
        }
      >
        {title} <LicensingTitle count={serviceLimit?.value} />
        <em>
          This service will be accessible for {humanizeDays(evaluationLimit?.value)}, unless you upgrade your license.
          <BillingUI>
            <Link to="/account/plans">Learn more.</Link>
          </BillingUI>
        </em>
      </Notice>
    )

  return null
}
